const podcastCategory = {
    story: "story",
    podcast: "podcast",
    shiur: "shiur",
};
export default podcastCategory;
